export default "/load-grad.png";